import HttpHandler from 'app/reusable/HttpHandler'
import * as types from './types'

/**
 * Fetches the current user's resolved feature flags from
 * GET /api/feature-flags/ and stores them.
 *
 * On success, replaces the store's flags with the response and persists
 * them to localStorage (see reducers.js). On failure (network error,
 * timeout, 5xx — see HttpHandler.getFeatureFlags) the
 * reducer deliberately leaves any previously-cached flags untouched: a
 * flaky/offline flags fetch must never block or degrade the rest of the
 * app, and the next login attempt calls this again (see
 * ducks/auth/actions.js#getUserInfo, which dispatches this after a
 * successful login).
 */
export const fetchFeatureFlags = (userId) => (dispatch) => {
  return HttpHandler.getFeatureFlags()
    .then(({ data }) => {
      dispatch({
        type: types.FETCH_FEATURE_FLAGS_SUCCESS,
        payload: { userId, flags: data || {}, timestamp: Date.now() },
      })
    })
    .catch((error) => {
      dispatch({
        type: types.FETCH_FEATURE_FLAGS_ERROR,
        payload: { userId, error },
      })
    })
}

/**
 * Resets the feature flags store and drops its persisted localStorage
 * cache. Not dispatched by the app itself — a reload deliberately boots
 * from that cache (see reducers.js#loadCachedState) — but available for
 * anything that needs to force an empty store.
 */
export const clearFeatureFlags = () => ({ type: types.CLEAR_FEATURE_FLAGS })
